const en = {
  howUseful: 'How useful you found this?',
  notUseful: 'Not useful',
  veryUseful: 'Very useful',
  thanks: 'Thank you for your contribution!',
};

export default en;
